// Logic for targeting envs is duplicated in the index.html for new relic.
// If you are changing something here, you might have to change it there as well
export var isStagingEnv = function isStagingEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  return /__env-stg__/.test(hostname) || /^stg/.test(hostname);
};
export var isProdEnv = function isProdEnv(hostname) {
  if (typeof window === 'undefined') return true;
  return /^members\.onepeloton/.test(hostname !== null && hostname !== void 0 ? hostname : window.location.hostname);
};
export var isUatEnv = function isUatEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  return /((secret|test|uat|xtest)\.onepeloton|(--)?members-onepeloton-com.netlify.app)/.test(hostname);
};
export var isLocalEnv = function isLocalEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  return /^local/.test(hostname);
};
export var isDeployPreviewEnv = function isDeployPreviewEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  return /^deploy-preview/.test(hostname);
};
export var isLightFeatureToggleState = function isLightFeatureToggleState() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  return isStagingEnv(hostname) || hostname.indexOf('toggle-light') > -1 || hostname.indexOf('--lit') > -1;
};
export var isCypressTest = function isCypressTest() {
  if (typeof window === 'undefined') return false;
  return !!window.Cypress;
};